import React, { useMemo } from "react";
import { Badge, ListGroup, ListGroupItem } from "reactstrap";
import { utils } from "../../../../../utils/utils";

const CraneInspectionSignature = ({ craneInspectionSignatures = [] }) => {
  const filteredSignatures = useMemo(() => {
    const employeeSignatures = craneInspectionSignatures.filter(
      (signature) => signature?.signatureType === "EMPLOYEE"
    );
    const customerSignatures = craneInspectionSignatures.filter(
      (signature) => signature?.signatureType === "CUSTOMER"
    );

    const mostRecentEmployee = employeeSignatures[0];
    const mostRecentCustomer = customerSignatures[0];

    return [mostRecentEmployee, mostRecentCustomer].filter(Boolean);
  }, [craneInspectionSignatures]);

  return (
    <ListGroup className="my-3 w-100">
      <ListGroupItem
        className="d-flex justify-content-between align-items-center bg-lighter font-500"
        tag="div"
      >
        <span>Crane Inspection Signature</span>
        {!filteredSignatures.length ? (
          <Badge pill color="danger">
            Signatures not provided
          </Badge>
        ) : null}
      </ListGroupItem>

      {filteredSignatures.map((signature, index) => (
        <ListGroupItem
          key={index}
          className="d-flex justify-content-between align-items-start"
        >
          <div className="d-flex flex-column flex-grow-1">
            <img
              alt={signature?.signatureType || signature?.signerName}
              className="my-3 col-12 col-md-6 col-lg-4 col-xl-3"
              src={signature?.signatureURL}
            />
            <small>
              <i>
                {signature?.signerName ||
                  (signature?.signatureType === "EMPLOYEE"
                    ? "DESHAZO, LLC"
                    : "CUSTOMER WITNESS")}
              </i>
            </small>
            {signature?.signerTitle && (
              <small>
                <i>
                  <br />
                  TITLE: {signature?.signerTitle}
                </i>
              </small>
            )}
          </div>
          <Badge color="info">
            {utils.formatDateTime(
              signature?.signatureDate,
              "MM/DD/YYYY, h:mm a"
            )}
          </Badge>
        </ListGroupItem>
      ))}
    </ListGroup>
  );
};

export default CraneInspectionSignature;
